// Google Analytics (UA) loader.
//
// Only initializes when the server has flagged that the current customer has
// accepted cookies, which is exposed via `data-analytics-enabled="true"` on
// the <body> element (set in app/views/layouts/application.html.haml).
//
// CSP note: the dynamically-inserted analytics.js <script> tag does not carry
// the page nonce, but `https://www.google-analytics.com` is allow-listed in
// `script-src` (see config/initializers/content_security_policy.rb), so it is
// permitted by the policy.

document.addEventListener('DOMContentLoaded', () => {
  const analyticsEnabled = document.body && document.body.dataset.analyticsEnabled === 'true';

  if (analyticsEnabled) {
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

      ga('create', 'UA-86860856-1', 'auto', { cookieFlags: 'SameSite=None; Secure' });
      ga('send', 'pageview');

      document.addEventListener('turbo:load', () => ga('send', 'pageview'));
  }
});
